import { noop, isFunction, isPlainObject, withProperties } from "../../../utils";

export default function __factory__(options) {
  const { key, actions, initialState, onSwitchedOff, onSwitchedOn } = isPlainObject(options) ? options : {};
  const { on: SWITCH_ON, off: SWITCH_OFF } = isPlainObject(actions) ? actions : {};

  if (SWITCH_ON && SWITCH_OFF && SWITCH_ON !== SWITCH_OFF) {
    const $this = this;
    const switchedOff = __callback__(onSwitchedOff);
    const switchedOn = __callback__(onSwitchedOn);

    const REDUCERS = withProperties(Object.create(null), {
      [ key || 'switch' ]: SwitchReducer(initialState)
    });

    function SwitchReducer(initialState = null) {
      initialState = initialState === true;

      return function __reducer__(state = initialState, action) {
        switch (action.type) {
          case SWITCH_ON: return state === true ? state : true;
          case SWITCH_OFF: return state === true ? false : state;
          default: return state;
        }
      }
    }

    function __callback__(fn) {
      return isFunction(fn) ? fn.bind($this) : noop;
    }

    return Object.defineProperty(REDUCERS, 'actions', {
      value: Object.freeze(
        withProperties(Object.create(null), {
          off() {
            return (dispatch) => {
              dispatch({ type: SWITCH_OFF });
              switchedOff();
            }
          },

          on() {
            return (dispatch) => {
              dispatch({ type: SWITCH_ON });
              switchedOn();
            }
          }
        })
      )
    });
  }

  throw new TypeError('Unique action identifiers are required for switch state.');
}
